export default __webpack_public_path__ + "static/media/OIDC_Configuration_Step1.3ceb86a8.png";